<template>
  <TransitionRoot as="template" :show="show">
    <Dialog as="div" class="fixed z-10 inset-0 overflow-y-auto" onClose="false">
      <div class="flex items-end justify-center min-h-screen text-center sm:block sm:p-0">
        <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
          <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </TransitionChild>

        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
        <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
          <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full">
            <div class="bg-green-400 text-left py-5 px-5 flex items-center align-middle justify-between">
              <div>
                <p class="text-yellowGreen">{{validationTranslation[language].note}}</p>
                  <DialogTitle as="h3" class="text-white text-3xl font-medium">
                    {{validationTranslation[language].title}}
                  </DialogTitle>
                </div>
                  <img src="@/assets/img/icons/wallet.svg" alt="">
            </div>
            <div class="px-4 pt-2 pb-5">
              <div class="w-full block text-left sm:mt-0 px-10">
                <div class="mt-8 text-left">
                  <p class="text-base text-gray-500 mb-3">
                    {{validationTranslation[language].subtitle}}
                  </p>
                  <ul class="text-base text-gray-500 mb-3 pl-10 list-disc">
                    <li v-for="(m, i) in message" :key="i">  {{m}}</li>
                    <li> {{validationTranslation[language].bbva}}  </li>
                  </ul>
                  
                </div>
              </div>

              <div class="px-4 py-3 sm:px-6 sm:flex sm:flex-col justify-center">
                <button type="button" class="md:w-6/12 sm:w-full text-white inline-flex justify-center rounded-md shadow-sm px-8 py-4 bg-green-200 text-base font-medium hover:bg-green-400 focus:outline-none focus:ring-green-400  my-5 mx-auto hover:text-white" @click="closeModal" ref="cancelButtonRef">
                    {{validationTranslation[language].buttonText}}
                </button>
                <p class="text-center mt-5" v-html="validationTranslation[language].footerText"> </p>
              </div>
            </div>
          </div>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import { Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { validationTranslation } from '@/translations/Validations.js'
import { dataLayerTryAgainPaymentMethod  } from '@/pixels/datalayer.js'

export default {
  props: ['show', 'validatedField'],
  data(){
    return{
      message : [],
      validationTranslation,
      language: localStorage.getItem('viva-translate') ? localStorage.getItem('viva-translate') : 'es',
    }
  },
  components: {
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
  },
  watch:{
    validatedField :{
      deep:true,
      handler( ){
        this.generateMessage()
      }
    }
  },
  methods: {
    closeModal() {
      dataLayerTryAgainPaymentMethod()
      setTimeout( () => {
         this.message = []
      }, 200 )
      this.$emit('close')
     
     
    },
    generateMessage(){

      const fields = [ 
          'number',
          'month', 
          'year',
          'first_name',
          'last_name',
          'general',
          'city',
          'country',
          'address1',
          'cvv',
          'UNKNOWN_RECURLY_ERROR',
          'insufficient_funds',
          'canceled_account']
      const messages = {
        number : this.validationTranslation[this.language].number,
        month :  this.validationTranslation[this.language].month,
        year : this.validationTranslation[this.language].year,
        first_name : this.validationTranslation[this.language].firstName,
        last_name : this.validationTranslation[this.language].lastName,
        code :  this.validationTranslation[this.language].ccv,
        general: this.validatedField.general,
        city: this.validationTranslation[this.language].city,
        country: this.validationTranslation[this.language].country,
        address1: this.validatedField.general,
        cvv: this.validationTranslation[this.language].ccv,
        insufficient_funds: this.validationTranslation[this.language].insufficient_funds,
        canceled_account: this.validationTranslation[this.language].canceled_account,
        UNKNOWN_RECURLY_ERROR: this.validationTranslation[this.language].unknown
      }


      Object.keys(this.validatedField).forEach( el =>{
        if( fields.includes(el) ){
          this.message.push(messages[el])
        }
      })

      
    }
  },
  
}
</script>